<template>
  <div class="container">
    <div class="desc">
      {{ sysConfig.websiteDesc || '了栀林-风与异乡人' }}
    </div>
    <div class="bottom">
      <div>{{ sysConfig.websiteVersion || '©V2.1.9-2025~了栀~' }}</div> 
      <div @click="handleLink" style="cursor: pointer;  text-decoration: underline;" class="beian">{{ sysConfig.websiteBeian || '陇ICP备2025021640号-2' }}</div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: 'BottomTip',
  computed: {
    // 从 vuex 中获取 sysConfig
    sysConfig() {
      return this.$store.state.sysConfig || {}
    }
  },
  methods: {
    handleLink() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    }
  }
}
</script>

<style scoped>
.container{
    width: 100%;
    height: 40px;
    position: relative;
    bottom: 0;
    padding-top: 10px;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.desc{
  font-size: 12px;
  color: #2c3e50;
    background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
    background-size: 400% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: gradientMove 8s ease-in-out infinite;
}


.bottom{
  padding-bottom: 20px; 
  font-size: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
    color: #2c3e50;
    background: linear-gradient(90deg, #ff0080, #ff8c00, #40e0d0, #9370db, #ff0080);
    background-size: 400% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: gradientMove 8s ease-in-out infinite;
}

@keyframes gradientMove {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}
</style>